import { NgModule } from '@angular/core';

import { SharedModule }               from '../shared/shared.module';
import { StockTakeQuickAddComponent } from './stock-take.quick-add.component';
import { StockTakeService }           from './stock-take.service';

@NgModule({
  declarations: [
    StockTakeQuickAddComponent
  ],
  entryComponents: [
    StockTakeQuickAddComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    StockTakeService
  ]
})
export class StockTakeModule {}
